<template>
  <v-layout>
    <v-tabs vertical class="my-tabs" v-model="active_tab">
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table-large</v-icon>តារាង​ ៥.ក ៥.ខ ៥.គ
      </v-tab>
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table-large</v-icon>តារាង​ ៥.ឃ
      </v-tab>
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table-large</v-icon>តារាង​ ៥.ង ៥.ច​
      </v-tab>
      <v-tab class="pl-1 ttext">
        <v-icon left>mdi-table-large</v-icon>តារាង​ ៥.ឆ ៥.ជ
      </v-tab>
      <v-tab-item>
        <div class="row">
          <div>
            <schoolarea :data="fac_5a" :title="title[1]" />
            <schoolconst :data="fac_5b" :title="title[2]" />
          </div>
          <div>
            <schoolroom :data="fac_5cc" :title="title[3]" />
          </div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="row">
          <div>
            <!--<schoolFac :data="fac_5c" :title="title[4]" /> Remove 2026-27 -->
            <handwashing :data="uti_5d" :lastRow="1" :title="title[4]" />
            <!-- LastRow is 0 for pre school only -->
          </div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="row">
          <div>
            <p></p>
            <toilet :data="uti_5e" :title="title[5]" />
          </div>
          <div>
            <water :data="uti_5f" :title="title[6]" />
          </div>
        </div>
      </v-tab-item>
      <v-tab-item>
        <div class="row">
          <div>
            <facility :data1="uti_5g1" :data2="uti_5g2" :title="title[7]" />
            <schoolsport :fdata="uti_5h1" :sdata="uti_5h2" :title="title[8]" />
          </div>
        </div>
      </v-tab-item>
    </v-tabs>
  </v-layout>
</template>

<script>
import schoolArea from "@/components/privateascf/sharedCom/privSchoolArea.vue";
import schoolConst from "@/components/privateascf/sharedCom/privSchoolConstruction.vue";
import schoolRoom from "@/components/privateascf/sharedCom/privSchoolRoom.vue";
//import schoolFac from "@/components/privateascf/sharedCom/privSchoolFacility.vue";
import handWashing from "@/components/ascf/sharedCom/handwashing.vue";
import toilet from "@/components/ascf/sharedCom/toilet.vue";
import WaterSource from "@/components/ascf/sharedCom/waterSource.vue";
import Facility from "@/components/ascf/sharedCom/facility.vue";
import schoolSport from "@/components/ascf/sharedCom/schoolSport.vue";

export default {
  props: [
    "title",
    "fac_5a",
    "fac_5b",
    //"fac_5c",
    "fac_5cc",
    "uti_5d",
    "uti_5e",
    "uti_5f",
    "uti_5g1",
    "uti_5g2",
    "uti_5h1",
    "uti_5h2",
  ],
  components: {
    schoolarea: schoolArea,
    schoolconst: schoolConst,
    schoolroom: schoolRoom,
    //schoolFac: schoolFac,
    handwashing: handWashing,
    toilet: toilet,
    water: WaterSource,
    facility: Facility,
    schoolsport: schoolSport,
  },
  data() {
    return {
      active_tab: 0,
    };
  },
  methods: {},
};
</script>
<style scoped>
.row {
  display: flex;
}
.ttext {
  font-family: "Siemreap";
  font-size: 12px;
  font-weight: bold;
}
div.my-tabs [role="tab"] {
  justify-content: flex-start;
}
</style>